import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const API = axios.create({ baseURL: `${BACKEND_URL}/api` });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("adl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default API;
